<template>
 
  <div class="linedemo"  ref="chartsDOM"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props:{
    data:{
      type:Array,
      require:false
    },
    provice:{
      type:String,
      require:false
    },
    vegetable:{
      type:String,
      require:false
    }
  },
  data(){
    return{
        provincedata:[],
        myChart:null,
        option:{},
        timeList:[],
        xAxisdata:[],
        legenddata:[],
        minarea:0,
        maxarea:0,
        maxyield:0,
        minyield:0,

    }
  },
  mounted(){
    console.log(this.data)
    this.timeList=this.data.map(item=>item.data.time)
    
    this.initChart();
    this.updateChart();

  },
  watch:{
    data(){
      console.log(this.data)
      this.timeList=this.data.map(item=>item.time)
      var areadata=this.data.map(item=>item.area)
      var yielddata=this.data.map(item=>item.yield)
      this.minarea=Math.min(...areadata)
      this.maxarea=Math.max(...areadata)
      
      this.minyield=Math.min(...yielddata)
      this.maxyield=Math.max(...yielddata)
      
      this.provincedata=[]
      this.provincedata.push({
        name: '单位面积碳足迹',
        type: 'line',
        data:areadata,
        yAxisIndex: 0
      })
      this.provincedata.push({
        name: '单位产量碳足迹',
        type: 'line',
        data:yielddata,
        yAxisIndex: 1
      })
      this.updateChart()
    }
  },
  methods:{
    initChart(){
      this.myChart = echarts.init(this.$refs["chartsDOM"]);
      // 显示 loading 动画
      this.myChart.showLoading();
      // 再得到数据的基础上，进行地图绘制
      this.myChart.hideLoading();
      this.option={
        // title: {
        //   text: 'Stacked Line',
        //    textAlign: 'center',
        //    left: '50%',         // 标题容器居中
           
        //   textStyle: {
        //     fontSize: 24,
        //   }  
        // },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            position: function (pt) {
               return [130,pt[1]];
            },
            formatter: function (params) {
    
                const itemData = params

                if(itemData.length==2)
                  return `${itemData[0].axisValue}<br>单位面积碳足迹：${itemData[0].data.toFixed(3)} t CO<sub>2</sub>e/hm<sup>2</sup><br>单位产量碳足迹：${itemData[1].data.toFixed(3)} kg CO<sub>2</sub>/kg`;
                else {
                  if (itemData[0].seriesName=="单位面积碳足迹")
                  return `${itemData[0].axisValue}<br>${itemData[0].seriesName}：${itemData[0].data.toFixed(3)} t CO<sub>2</sub>e/hm<sup>2</sup>`;
                  else
                  return `${itemData[0].axisValue}<br>${itemData[0].seriesName}：${itemData[0].data.toFixed(3)} kg CO<sub>2</sube/kg`;
                }
            }
            
          },
        // legend: {
        //    data: ['单位面积碳足迹','单位产量碳足迹'],
        // },
        legend: [
                // 左侧 legend
                {
                    data: ['单位面积碳足迹'],
                    textStyle: {
                      fontSize: 18, // 文字大小
                    },
                    left: '2%',
                    align: 'left'
                },
                // 右侧 legend
                {
                    textStyle: {
                      fontSize: 18, // 文字大小
                    },
                    data: ['单位产量碳足迹'],
                    right: '5%',
                    align: 'left'
                }
            ],
        grid: {
          left: '5%',
          right: '8%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [ ]
        },
        yAxis: [{
            type: 'value',
            name:'t CO{sub|2}e/hm{sup|2}',
            position:'left',
            nameTextStyle:{
                rich:{
                    sub: {
                    verticalAlign: "bottom",
                    fontSize: 8
                    },
                    sup:{
                    verticalAlign: "top",
                    fontSize: 8
                    }
                }
              },
            // axisLabel: {
            //             formatter: '{value}'
            //         },
            //scale: true
            min:0,
          },{
            type: 'value',
            name:'kg CO{sub|2}e/kg',
            position:'right',
            nameTextStyle:{
                rich:{
                    sub: {
                    verticalAlign: "bottom",
                    fontSize: 8
                    },
                    sup:{
                    verticalAlign: "top",
                    fontSize: 8
                    }
                }
              },
              min:0,
            // axisLabel: {
            //             formatter: '{value}'
            //         },
            //scale: true
          }],
        series: this.provincedata
      }
      this.myChart.setOption(this.option);
      console.log(123132)
    },
    updateChart(){
      
      // this.legenddata=this.crops.map((obj)=>obj.name)
      this.option.xAxis.data=this.timeList
      this.option.series=this.provincedata
      // this.option.title.text=this.provice+" "+this.vegetable
      
      // var y0=Math.floor(this.minarea-(this.maxarea-this.minarea)/2)
      // var y1=Math.floor(this.minyield-(this.maxyield-this.minyield)/2)
      // this.option.yAxis[0].min=y0>0?y0:0
      //this.option.yAxis[0].max=this.maxarea
      //this.option.yAxis[1].max=this.maxyield
      this.option.yAxis[0].min=0
      this.option.yAxis[1].min=0
      this.myChart.setOption(this.option,true)
      console.log(123123)
    }
  }
   
}
</script>


<style>
.linedemo{
    width: 100%;
    height: 100%;
}
</style>